<div [ngClass]="{ wrap: wrapContent }">
  <div class="equipment-print-header print-header">
    @if (!payload?.properties?.hideLabel?.value && payload?.properties?.text?.value) {
      <div class="header">
        <div class="title">
          <span [innerHTML]="payload?.properties?.text?.value | tokenToDiv"></span>
          @if (payload?.properties?.required?.value) {
            <span class="required">*</span>
          }
        </div>
        <span class="message">* populated from PatientNow</span>
      </div>
    }

    @if (payload?.properties?.content?.value) {
      <div class="flex flex-row">
        <div class="flex word-wrap mb10">
          <label class="flex subtitle">
            <span [innerHTML]="payload?.properties?.content?.value | tokenToDiv"></span>
          </label>
        </div>
      </div>
    }

    <mat-divider></mat-divider>
  </div>

  @let visibleEntries = getVisibleEquipmentEntries();
  @if (!isPrinting || visibleEntries.length > 0) {
    <form
      class="equipment-card"
      [class.equipment-card--editor]="isDesign"
      [class.equipment-card--print]="isPrinting"
      [formGroup]="equipmentForm"
    >
      @if (!isWidgetHidden) {
        <div class="equipment-list" formArrayName="items">
          @for (entry of visibleEntries; track entry.index) {
            <div class="equipment-item" [formGroupName]="entry.index">
              @let equipmentGroup = entry.group;
              <div class="equipment-section">
                <h4 class="section-title">Equipment Entry</h4>

                <div class="equipment-row">
                  <div class="equipment-field equipment-field--full">
                    <label class="equipment-field-label">
                      <span class="equipment-field-label__content">
                        <span>Equipment Type</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getEquipmentMarkerTarget(entry.index)"
                          fieldKey="equipmentType"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [rowIndex]="entry.index" fieldKey="equipmentType" />
                      </span>
                    </label>
                    <ng-select
                      class="equipment-select"
                      [class.equipment-select--invalid]="isEquipmentTypeInvalid(equipmentGroup)"
                      formControlName="equipmentType"
                      [items]="equipmentTypes$ | async"
                      bindLabel="text"
                      bindValue="value"
                      placeholder="Equipment Type"
                      [searchable]="true"
                      [searchFn]="customSearchFn"
                      [virtualScroll]="true"
                      [loading]="isLoadingEquipment"
                      [clearable]="true"
                      [minTermLength]="0"
                      dropdownPosition="auto"
                      appendTo="body"
                      (scrollToEnd)="onScrollToEnd()"
                      (search)="onSearch($event)"
                      (open)="onDropdownOpen()"
                      (change)="clearEquipmentMarker(entry.index, 'equipmentType')"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.text }}
                      </ng-template>
                    </ng-select>
                    @if (isEquipmentTypeInvalid(equipmentGroup)) {
                      <div class="equipment-error">Equipment Type is required.</div>
                    }
                  </div>
                </div>

                <div class="equipment-row">
                  <div class="equipment-field equipment-field--third">
                    <label class="equipment-field-label">
                      <span class="equipment-field-label__content">
                        <span>Time</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getEquipmentMarkerTarget(entry.index)"
                          fieldKey="time"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [rowIndex]="entry.index" fieldKey="time" />
                      </span>
                    </label>
                    <input
                      class="equipment-input"
                      [class.equipment-input--invalid]="isTimeInvalid(equipmentGroup)"
                      type="text"
                      formControlName="time"
                      placeholder="Time (min)"
                      aria-label="Time in minutes"
                      (blur)="onTimeBlur(equipmentGroup)"
                      (input)="clearEquipmentMarker(entry.index, 'time')"
                    />
                    @if (isTimeInvalid(equipmentGroup)) {
                      <div class="equipment-error">Please enter a valid time using numbers only.</div>
                    }
                  </div>

                  <div class="equipment-field equipment-field--third">
                    <label class="equipment-field-label">
                      <span class="equipment-field-label__content">
                        <span>Quantity</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getEquipmentMarkerTarget(entry.index)"
                          fieldKey="quantity"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [rowIndex]="entry.index" fieldKey="quantity" />
                      </span>
                    </label>
                    <input
                      class="equipment-input"
                      [class.equipment-input--invalid]="isQuantityInvalid(equipmentGroup)"
                      type="text"
                      formControlName="quantity"
                      placeholder="Quantity"
                      aria-label="Quantity"
                      (blur)="onQuantityBlur(equipmentGroup)"
                      (input)="clearEquipmentMarker(entry.index, 'quantity')"
                    />
                    @if (isQuantityInvalid(equipmentGroup)) {
                      <div class="equipment-error">Please enter a valid quantity using numbers only.</div>
                    }
                  </div>

                  <div class="equipment-field equipment-field--third">
                    <label class="equipment-field-label">
                      <span class="equipment-field-label__content">
                        <span>Duration</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getEquipmentMarkerTarget(entry.index)"
                          fieldKey="unit"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [rowIndex]="entry.index" fieldKey="unit" />
                      </span>
                    </label>
                    <input
                      class="equipment-input"
                      [class.equipment-input--invalid]="isUnitInvalid(equipmentGroup)"
                      type="text"
                      formControlName="unit"
                      placeholder="Unit"
                      aria-label="Unit"
                      (blur)="onUnitBlur(equipmentGroup)"
                      (input)="clearEquipmentMarker(entry.index, 'unit')"
                    />
                    @if (isUnitInvalid(equipmentGroup)) {
                      <div class="equipment-error">Please enter a valid unit using numbers only.</div>
                    }
                  </div>
                </div>

                <div class="equipment-row">
                  <div class="equipment-field equipment-field--full">
                    <label class="equipment-field-label">
                      <span class="equipment-field-label__content">
                        <span>Notes</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getEquipmentMarkerTarget(entry.index)"
                          fieldKey="notes"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [rowIndex]="entry.index" fieldKey="notes" />
                      </span>
                    </label>
                    <textarea
                      appPasteStrip
                      appTextareaAutosize
                      [appTextareaAutosizeUnlimited]="isPrinting"
                      class="equipment-textarea"
                      [class.equipment-textarea--print]="isPrinting"
                      formControlName="notes"
                      placeholder="Notes"
                      aria-label="Notes"
                      (input)="clearEquipmentMarker(entry.index, 'notes')"
                    ></textarea>
                  </div>
                </div>
              </div>

              @if (!isPrinting || hasVisibleAttributes(equipmentGroup)) {
                <div class="equipment-section">
                  <h4 class="section-title">Attribute(s)</h4>

                  @for (attrIndex of getVisibleAttributeIndexesForRender(equipmentGroup); track attrIndex) {
                    <div class="equipment-row">
                      <div class="equipment-field equipment-field--full">
                        <label class="equipment-field-label">
                          <span class="equipment-field-label__content">
                            <span>Attribute {{ attrIndex }}</span>
                            <fb-scribe-suggestion-indicator
                              [target]="getEquipmentMarkerTarget(entry.index)"
                              [fieldKey]="'attribute' + attrIndex"
                            ></fb-scribe-suggestion-indicator>
                            <fb-amendment-field-indicator
                              [rowIndex]="entry.index"
                              [fieldKey]="'attribute' + attrIndex"
                            />
                          </span>
                        </label>
                        <ng-select
                          class="equipment-select"
                          [formControlName]="getAttributeControlName(attrIndex)"
                          [items]="getAttributeOptions(attrIndex, equipmentGroup)"
                          bindLabel="text"
                          bindValue="value"
                          [placeholder]="'Attribute ' + attrIndex"
                          [searchable]="true"
                          [loading]="isLoadingAttributes"
                          [clearable]="true"
                          dropdownPosition="auto"
                          appendTo="body"
                          (scrollToEnd)="onAttributeScrollToEnd()"
                          (search)="onAttributeSearch($event)"
                          (open)="onAttributeDropdownOpen()"
                          (change)="clearEquipmentMarker(entry.index, 'attribute' + attrIndex)"
                        >
                          <ng-template ng-option-tmp let-item="item">
                            {{ item.text }}
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  }
                </div>
              }

              @if (!isPrinting && !isEmrReadonly) {
                <button
                  type="button"
                  class="remove-equipment-btn"
                  (click)="removeEquipment(equipmentGroup)"
                  [disabled]="isDesign || isPrinting"
                  [class.remove-equipment-btn--disabled]="isDesign || isPrinting"
                  aria-label="Remove equipment"
                >
                  <rx-icon name="icon-close"></rx-icon>
                </button>
              }
            </div>
          }
        </div>
      }

      @if (!isPrinting && !isEmrReadonly) {
        <button type="button" class="add-equipment-btn" (click)="addEquipment()" [disabled]="isDesign || isPrinting">
          <span class="add-equipment-icon">
            <rx-icon name="icon-circle-plus-2" [size]="16"></rx-icon>
          </span>
          <span>Add Equipment</span>
        </button>
      }

      @if (isEmrReadonly) {
        <fb-emr-readonly-notice />
      }
    </form>
  }

  @if (payload?.properties?.hint?.value) {
    <div class="hint" [innerHTML]="payload?.properties?.hint?.value | tokenToDiv"></div>
  }

  @if (isSubmitted && getErrorName() === 'required') {
    <div class="hint-required">This field is required</div>
  }
</div>
